import { createRoot } from 'react-dom/client'
// Self-hosted variable fonts (Vite bundles the woff2s same-origin) — no runtime Google Fonts
// dependency, so the app renders its real type offline/firewalled and leaks no tenant IPs to a CDN.
import '@fontsource-variable/space-grotesk'
import '@fontsource-variable/jetbrains-mono'
import './styles/tokens.css'
import './styles/app.css'
import './styles/theme.css'
import App from './app.jsx'
import { AuthGate } from './auth.jsx'

createRoot(document.getElementById('root')).render(
  <AuthGate><App /></AuthGate>
)
